import { Card } from "antd";

const AnalyticsCard = ({ data }) => {
  return (
    <div>
      <Card className="m-2">
        <div className="m-2">
          <p className="text-lg font-medium">Total</p>
          <div className=" grid justify-center xl:grid-cols-5 md:grid-cols-3 grid-cols-2 rounded">
            <div className="ml-2">
              <p className="text-primaryPurple">Gross Volume</p>
              <p className="text-xl font-light mt-0 truncate">
                ${data?.totalGrossVolume?.toFixed(2) ?? 0}
              </p>
            </div>
            <div>
              <p className="text-primaryPurple">Sales</p>
              <p className="text-xl font-light  mt-0">
                {data?.totalSales ?? 0}
              </p>
            </div>
            <div className="ml-2 md:ml-0">
              <p className="text-primaryPurple">Customers</p>
              <p className="text-xl font-light  mt-0">
                {data?.totalCustomers?.length ?? 0}
              </p>
            </div>
            <div className="ml-2 xl:ml-0">
              <p className="text-primaryPurple">Appointments</p>
              <p className="text-xl font-light  mt-0">
                {data?.totalAppointments ?? 0}
              </p>
            </div>
            <div className="ml-2 md:ml-0">
              <p className="text-primaryPurple">Payouts</p>
              <p className="text-xl font-light  mt-0">
                ${data?.totalPayouts?.toFixed(2) ?? 0}
              </p>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
export default AnalyticsCard;
